var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { css, styled } from "styled-components";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
var Badge = styled.div.withConfig({
  componentId: "sc-w206i8-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: inline-block;\n    background-color: ", ";\n    padding: ", " ", ";\n    border-radius: ", ";\n  "])), getColor(theme, "backgroundLightTint"), space(1), space(1.5), getBorderRadius(theme, "large"));
});
export default Badge;